import {Col, message, Row} from "antd";
import {useAuth} from "../context/Auth";
import {useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import SignInForm from "../components/SignInForm";
import Api from "../common/Api";
import {AxiosError} from "axios";
import Storage from "../common/StorageHelper";
import SignInNewPasswordForm from "../components/SignInNewPasswordForm";
import ForgotPasswordForm from "../components/ForgotPasswordForm";

const SignIn = () => {
    const [spinning, setSpinning] = useState(false);
    const [session, setSession] = useState("");
    const [codeSent, setCodeSent] = useState(false);
    const [challenge, setChallenge] = useState<"SIGN-IN" | "NEW_PASSWORD_REQUIRED" | "FORGOT_PASSWORD">("SIGN-IN")
    const {setUser, user} = useAuth()
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const reCaptchaRef = useRef<any>([]);

    useEffect(() => {
        if (user)
            navigate("/", {replace: true});
    })


    const newPassword = async (values: any) => {
        try {
            setSpinning(true)
            const {data: captcha} = await Api.management.verifyCaptcha(values.captcha);
            if (!captcha.success) {
                reCaptchaRef.current[2].reset();
                return message.error('Invalid captcha')
            }
            const {data} = await Api.management.changePassword(
                values.email, values.password, session)
            Storage.configure(data.AuthenticationResult)
            setUser(Storage.getUser())
        } catch (e) {
            reCaptchaRef.current[2].reset();
            if (e instanceof AxiosError) {
                const error = e as AxiosError;
                return message.error(error.response?.data as string);
            }
            console.error(e)
            message.error('Unknown error')
        } finally {
            setSpinning(false)
        }
    };

    const onFinish = async (values: any) => {
        try {
            setSpinning(true)
            const {data: captcha} = await Api.management.verifyCaptcha(values.captcha);
            if (!captcha.success) {
                reCaptchaRef.current[0].reset();
                return message.error('Invalid captcha')
            }
            const {data} = await Api.management.signIn(
                values.email, values.password)
            setEmail(values.email)
            if (data.ChallengeName === "NEW_PASSWORD_REQUIRED") {
                setSession(data.Session)
                return setChallenge("NEW_PASSWORD_REQUIRED")
            }
            Storage.configure(data.AuthenticationResult)
            setUser(Storage.getUser())
        } catch (e) {
            reCaptchaRef.current[0].reset();
            if (e instanceof AxiosError) {
                const error = e as AxiosError;
                return message.error(error.response?.data as string);
            }
            console.error(e)
            message.error('Unknown error')
        } finally {
            setSpinning(false)
        }
    };

    const onFinishFailed = async (errorInfo: any) => {
        console.error('Failed:', errorInfo);
    };

    const forgotPassword = async (state: string, values: any) => {
        console.log(state, values);
        setSpinning(true)
        const {data: captcha} = await Api.management.verifyCaptcha(values.captcha);
        if (!captcha.success) {
            reCaptchaRef.current[1].reset();
            return message.error('Invalid captcha')
        }
        if (state === "SEND_CODE") {
            try {
                await Api.management.forgotPasswordSendCode(values.email);
                setCodeSent(true)
                reCaptchaRef.current[1].reset();
                message.success('Code sent!')
            } catch (e) {
                reCaptchaRef.current[1].reset();
                setCodeSent(false)
                if (e instanceof AxiosError) {
                    const error = e as AxiosError;
                    return message.error(error.response?.data as string);
                }
                console.error(e)
                message.error('Unknown error')
            } finally {
                setSpinning(false)
            }
        }
        if (state === "UPDATE_PASSWORD") {
            try {
                await Api.management.forgotPasswordChangePassword({
                    username: values.email,
                    code: values.code,
                    password: values.password
                });
                message.success('Password updated!')
                setChallenge("SIGN-IN")
            } catch (e) {
                reCaptchaRef.current[1].reset();
                if (e instanceof AxiosError) {
                    const error = e as AxiosError;
                    return message.error(error.response?.data as string);
                }
                console.error(e)
                message.error('Unknown error')
            } finally {
                setSpinning(false)
            }
        }
    }


    const challenges = {
        "SIGN-IN": <SignInForm recaptchaRef={reCaptchaRef} setChallenge={setChallenge} onFinish={onFinish}
                               onFinishFailed={onFinishFailed}
                               spinning={spinning}/>,
        "NEW_PASSWORD_REQUIRED": <SignInNewPasswordForm recaptchaRef={reCaptchaRef}
                                                        email={email} spinning={spinning} onFinish={newPassword}
                                                        onFinishFailed={onFinishFailed}/>,
        "FORGOT_PASSWORD": <ForgotPasswordForm setChallenge={setChallenge} recaptchaRef={reCaptchaRef}
                                               codeSent={codeSent} spinning={spinning} onFinish={forgotPassword}
                                               onFinishFailed={onFinishFailed}/>
    }

    return (
        <Row align="middle">
            <Col span={24} xs={{span: 22, offset: 1}}>
                {challenges[challenge]}
            </Col>
        </Row>
    )
}

export default SignIn;
